import { buildLoader } from '../util/GenericLoader';
import { getUnitPreferencesAction } from '../../redux/actions/unitPrefs';

export default buildLoader(getUnitPreferencesAction);
